<div class="sidenav-content">
  <app-nav-list [portfolio]="portfolio" (closeSidenav)="onSidenavClose()" [isAdmin]="isAdmin"></app-nav-list>
</div>
